<template>
  <v-container fluid class="fill-height secondary lighten-1 gradient">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="10" md="7" lg="6" xl="4">
        <v-card class="secondary">
          <v-card-actions
            class="text-center justify-center py-2 white-gradient"
          >
            <router-link class="nolink" to="/">
              <img src="/vp_sm.png" style="width: 100%; height: auto" />
            </router-link>
          </v-card-actions>
          <v-tabs
            v-model="tab"
            background-color="secondary"
            dark
            :grow="true"
            :slider-size="5"
          >
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab :href="`#login`" tile>Sign In</v-tab>
            <v-tab :href="`#register`" tile>Sign Up</v-tab>
            <v-tab :href="`#forgot`" hide style="display: none"></v-tab>
            <v-tab :href="`#reset`" hide style="display: none"></v-tab>

            <v-tab-item value="reset">
              <reset @tab="switchTab"></reset>
            </v-tab-item>
            <v-tab-item value="forgot">
              <forgot @tab="switchTab"></forgot>
            </v-tab-item>
            <v-tab-item value="login">
              <login @tab="switchTab"></login>
            </v-tab-item>
            <v-tab-item value="register">
              <register @tab="switchTab"></register>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import login from "@/components/login/login";
import register from "@/components/login/register";
import reset from "@/components/login/reset";
import forgot from "@/components/login/forgot";

export default {
  name: "",
  components: {
    login,
    register,
    reset,
    forgot,
  },
  data: () => ({
    tab: "login",
  }),
  methods: {
    switchTab(tab) {
      this.tab = tab;
    },
  },
  computed: {},
  created() {
    if (this.$store.getters["isLoggedIn"]) {
      return this.$router.push("/portals");
    }
    if (this.$route.query.token) {
      setTimeout(
        function () {
          this.tab = "reset";
        }.bind(this),
        100
      );
    }
    if (this.$route.hash.includes("forgot")) {
      setTimeout(
        function () {
          this.tab = "forgot";
        }.bind(this),
        100
      );
    }
    if (this.$route.name === "Register") {
      setTimeout(
        function () {
          this.tab = "register";
        }.bind(this),
        100
      );
    }
    if (this.$route.query.continue) {
      this.$store.commit("set_continue", this.$route.query.continue);
    }
  },
};
</script>
<style lang="scss" scoped>
@font-face {
  font-family: "Arial Rounded MT Bold";
  src: url("/fonts/ArialRoundedMTBold.ttf"),
    url("/fonts/ArialRoundedMTBold.eot?"), url("/fonts/ArialRoundedMTBold.svg");
}

.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 64px;
  letter-spacing: -2.3px;
}

.gradient {
  background: #fc466b;
  background: -webkit-linear-gradient(to right, #3f5efb, #fc466b);
  background: linear-gradient(to right, #3f5efb, #fc466b);
}
.bg {
  background-size: cover;
  background-position-y: center;
  background-position-x: center;
  z-index: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
